const OUTCOME_LABELS = {
  preparing: 'Preparing',
  ready: 'Waiting for delivery',
  sending: 'Delivering',
  blocked: 'File or destination unavailable',
  failed: 'Upload Failed',
  retryable: 'File or destination unavailable',
  // Cached legacy uncertainty uses the same failure label.
  uncertain: 'Upload Failed',
  chart_delivered: 'Uploaded to chart',
  sftp_delivered: 'Delivered to SFTP',
};

export const getPacketUploadStatus = (packet) => {
  if (!packet || !Array.isArray(packet.parts) || packet.parts.length === 0) return null;

  const complete = packet.delivered === packet.total;
  const needsAttention = packet.parts.some((part) => ['failed', 'retryable', 'uncertain', 'blocked'].includes(part.outcome));
  const label = `${packet.delivered}/${packet.total} parts delivered`;
  const parts = packet.parts.map((part) => (
    `${part.category} · Pages ${part.pages.join(', ')}${part.date_of_service ? ` · ${part.date_of_service}` : ''}: ${OUTCOME_LABELS[part.outcome] || 'Waiting'}`
  ));
  let severity = needsAttention ? 'warning' : 'info';
  if (complete) severity = 'success';
  return {
    statusKey: 'packet_upload',
    severity,
    label,
    message: [label, ...parts].join('\n'),
    link: /^https?:\/\//i.test(packet.chart_link || '') ? packet.chart_link : null,
  };
};

export default getPacketUploadStatus;
